import React, { useEffect, useState } from 'react'
import { useLandingsList } from './hooks'
import { CButton, CCardBody } from '@coreui/react-pro'
import { path } from '../../../../../libs'
import { Table, Tag } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { Landing } from './types'

export const LandingList: React.FC = () => {
  const { landings, totalCountOfLandings, loading, onChangeLandingsList } =
    useLandingsList()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
  }: {
    currentPage?: number
    currentPageSize?: number
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
  }

  useEffect(() => {
    onChangeLandingsList({
      limit: pageSize,
      page: page,
    })
  }, [pageSize, page])

  const columns: ColumnsType<Landing> = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Language',
      dataIndex: 'lang',
      key: 'lang',
    },
    {
      title: 'Link',
      dataIndex: 'link',
    },
    {
      title: 'Status',
      dataIndex: 'isVisible',
      render: (status: boolean) => {
        return (
          <Tag color={status ? 'success' : 'error'}>
            {status ? 'Active' : 'Inactive'}
          </Tag>
        )
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              href={path.ib.ad.landing.edit(item.id)}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <CButton
        color="primary"
        className="mb-2"
        href={path.ib.ad.landing.create()}
      >
        Create landing
      </CButton>
      <Table
        dataSource={landings}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="landingTable"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfLandings,
        }}
        onChange={(pagination, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      ></Table>
    </CCardBody>
  )
}
